module.exports = __webpack_public_path__ + "static/media/icon-create-project.a62c71ed.svg";